import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FreespinOutro} from "../../runnerpresentations/freespin/FreespinOutro";
import {FreespinSetSticky} from "../../runnerpresentations/freespin/FreespinSetSticky";
import {UpdateTotalMultiplerFs} from "../../runnerpresentations/freespin/UpdateTotalMultiplierFs";
import {UnlockFsArea} from "../../runnerpresentations/freespin/UnlockFsAreas";
import {TopOne} from "../../runnerpresentations/freespin/topFeatures/TopOne";
import {TopTwo} from "../../runnerpresentations/freespin/topFeatures/TopTwo";
import {TopThree} from "../../runnerpresentations/freespin/topFeatures/TopThree";
import {TopFour} from "../../runnerpresentations/freespin/topFeatures/TopFour";
import {TopFive} from "../../runnerpresentations/freespin/topFeatures/TopFive";
import {SuperFreespinOutro} from "../../runnerpresentations/superfreespin/SuperFreespinOutro";
import {RightOne} from "../../runnerpresentations/freespin/rightFeatures/RightOne";
import {RightTwo} from "../../runnerpresentations/freespin/rightFeatures/RightTwo";
import {RightFive} from "../../runnerpresentations/freespin/rightFeatures/RightFive";
import {RightFour} from "../../runnerpresentations/freespin/rightFeatures/RightFour";
import {RightThree} from "../../runnerpresentations/freespin/rightFeatures/RightThree";
import {EndBonusPresentation} from "../../runnerpresentations/EndBonusPresentation";
import {FeatureEndOfRound} from "../../runnerpresentations/FeatureEndOfRound";
import {WinSummary} from "../../runnerpresentations/WinSummary";
import {BrokeTheBankPresentation} from "../../runnerpresentations/BrokeTheBankPresentation";

export class DevilsCrossroadFreespinWin implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            new FreespinSetSticky(),
            new UnlockFsArea(),

            //new UpdateCoinValuesFs(),
            new TopOne(),
            new TopTwo(),
            new TopThree(),
            new TopFour(),
            new TopFive(),
            new RightOne(),
            new RightTwo(),
            new RightThree(),
            new RightFour(),
            new RightFive(),
            new FeatureEndOfRound(),

            new UpdateTotalMultiplerFs(),
            new EndBonusPresentation(),
            new WinSummary(),
            new FreespinOutro(),
            new SuperFreespinOutro(),
            new BrokeTheBankPresentation()

        ];
    }

    start(flowStateController: FlowStateController): void {

        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "DevilsCrossroadFreespinWin");
    }

}